import {Injectable} from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import {Observable} from 'rxjs';
import {UserService} from "../service/user.service";

@Injectable({
    providedIn: 'root'
})
export class IsNotLoggedGuard  {
    constructor(
        private router: Router,
        private userService: UserService
    ) {
    }

    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
            if (this.userService.isLogged()) {
            return true;
        } else {
            this.userService.urlRedirection = state.url;
            return this.router.parseUrl('/auth/login');
        }
    }

}
